import { Component, OnInit, computed, inject } from '@angular/core';
import {
  Router,
  RouterOutlet,
} from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { LoaderComponent } from './core/components/loader/loader.component';
import { LoaderService } from './core/services/loader.service';
import { suivreNavigation } from './core/services/navigation-loader';
import { CurrencyService } from './core/services/models/currency.service';
import { DemoStatusService } from './core/services/demo-status.service';
import { EnvironmentStatusService } from './core/services/environment-status.service';

import { NouvelleVersionComponent } from './core/components/nouvelle-version/nouvelle-version.component';
@Component({
  selector: 'app-root',
  imports: [NouvelleVersionComponent, RouterOutlet, ToastModule, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private currencyService = inject(CurrencyService);
  private router = inject(Router);
  private loader = inject(LoaderService);
  private demoStatus = inject(DemoStatusService);
  private environmentStatus = inject(EnvironmentStatusService);

  /** Instance de test (préprod) : bandeau jaune-orangé en haut de l'écran. */
  readonly isTestInstance = this.environmentStatus.isTest;
  title = 'moni';

  /** Bandeau de démonstration : uniquement sur le build `demo`, et une fois la date connue. */
  readonly demoReset = this.demoStatus.nextReset;

  /** « mercredi 31 juillet à 23:32 », dans le fuseau du visiteur. */
  readonly demoResetLabel = computed(() => {
    const date = this.demoReset();
    if (!date) { return ''; }

    return new Intl.DateTimeFormat('fr-FR', {
      weekday: 'long', day: 'numeric', month: 'long',
      hour: '2-digit', minute: '2-digit',
    }).format(date);
  });

  ngOnInit(): void {
    this.demoStatus.load();
    this.environmentStatus.load();
    this.currencyService.loadBase();
    // Loader de navigation, suspendu pendant les gardes (confirmation de sortie).
    suivreNavigation(this.router.events, this.loader);
  }
}
